export function mapMobileFuelToTypeOfFuel(
  mobileFuelType: string
): string | null {
  // Mobile combustion fuel keys are "short" (e.g. diesel_100_pct_mineral_diesel)
  // while Scope 1 stationary / Scope 3 WTT fuels use the TypeOfFuel enum values
  // (e.g. liquid_fules.diesel_100_pct_mineral).
  const mapping: Record<string, string> = {
    cng: 'gaseous_fuel.cng',
    lng: 'gaseous_fuel.lng',
    lpg: 'gaseous_fuel.lpg',
    natural_gas: 'gaseous_fuel.natural_gas',
    natural_gas_100_pct_mineral_blend:
      'gaseous_fuel.natural_gas_100_pct_mineral_blend',

    aviation_spirit: 'liquid_fules.aviation_spirit',
    aviation_turbine_fuel: 'liquid_fules.aviation_turbine_fuel',
    burning_oil: 'liquid_fules.burning_oil',
    diesel_average_biofuel_blend: 'liquid_fules.diesel_average_biofuel_blend',
    diesel_100_pct_mineral_diesel: 'liquid_fules.diesel_100_pct_mineral',
    fuel_oil: 'liquid_fules.fuel_oil',
    gas_oil: 'liquid_fules.gas_oil',
    lubricants: 'liquid_fules.lubricants',
    naphtha: 'liquid_fules.naphtha',
    petrol_average_biofuel_blend: 'liquid_fules.petrol_average_biofuel_blend',
    petrol_100_pct_mineral_petrol: 'liquid_fules.petrol_100_pct_mineral',
    processed_fuel_oils_residual_oil:
      'liquid_fules.processed_fuel_oils_residual_oil',
    processed_fuel_oils_distillate_oil:
      'liquid_fules.processed_fuel_oils_distillate_oil',
    waste_oils: 'liquid_fules.waste_oils',
    marine_gas_oil: 'liquid_fules.marine_gas_oil',
    marine_fuel_oil: 'liquid_fules.marine_fuel_oil',
  };

  if (mobileFuelType === 'other_manual_factor') return null;
  return mapping[mobileFuelType] ?? null;
}
